module.exports = __webpack_public_path__ + "media/cloudview-poster.96490a24.mp4";